<template>
  <a-card class="card-class">
    <a-button type="primary" @click="loadData()">刷新</a-button>
    <div class="table-div">
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
      >
        <template slot="izActivity" slot-scope="text">
          <span v-if="text === 1" class="green">启用</span>
          <span v-if="text === 0" class="red">禁用</span>
        </template>
        <a-popconfirm
          title="确定删除吗?"
          @confirm="() => handleDelete(record)"
          slot="action"
          slot-scope="text, record"
        >
          <a>删除</a>
        </a-popconfirm>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { getBusServermanageServiceList, getServiceListByAppId,deleteByServiceAppId } from '@/api/api.js'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  mixins: [JeecgListMixin],
  name: 'ServiceList',
  props: {
    serverId: {
      type: String,
      default: '',
    },
    appId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dataSource: [],
      loading: false,
      columns: [
        {
          title: '排序',
          align: 'center',
          dataIndex: 'sort',
        },
        {
          title: '服务名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '所属服务器id',
          align: 'center',
          dataIndex: 'serverId_dictText',
        },
        {
          title: '端口号',
          align: 'center',
          dataIndex: 'port',
        },
        {
          title: '分类',
          align: 'center',
          dataIndex: 'type_dictText',
        },
        {
          title: '文件位置',
          align: 'center',
          dataIndex: 'fileSrc',
        },
        {
          title: '启用',
          align: 'center',
          dataIndex: 'izActivity',
          scopedSlots: {
            customRender: 'izActivity',
          },
        },
      ],
      url: {
        delete: '/servermanage/busServermanageService/delete',
      },
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 999,
      },
      /* 排序参数 */
      isorter: {
        column: 'sort',
        order: 'asc',
      },
    }
  },
  mounted() {
    if(this.appId){
      this.columns.push({
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: { customRender: 'action' },
      })
    }
  },
  methods: {
    loadData() {
      this.dataSource = []
      var params = this.getQueryParams()
      if (this.serverId) {
        //服务器 ————》服务关联关系表
        params.serverId = this.serverId
        this.loading = true
        getBusServermanageServiceList(params)
          .then((res) => {
            if (res.success) {
              this.dataSource = res.result.records
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else if (this.appId) {
        //应用 ————》服务关联关系表
        params.appId = this.appId
        this.loading = true
        getServiceListByAppId(params)
          .then((res) => {
            if (res.success) {
              this.dataSource = res.result.records
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    handleDelete(record){
       if (this.serverId) {
        //服务器 ————》服务关联关系表
        
       }else if (this.appId){
         //应用 ————》服务关联关系表
         deleteByServiceAppId({serviceId:record.id,appId:this.appId}).then((res) => {
            if (res.success) {
              this.$message.success("删除成功")
              this.loadData();
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
       }
    }
  },
  watch: {
    serverId(newValue, oldValue) {
      this.loadData()
    },
    appId(newValue, oldValue) {
      this.loadData()
    },
  },
}
</script>

<style lang="less" scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.card-class {
  min-height: 900px;
}
.table-div{
  margin-top: 20px;
}
</style>